
export const Provincias = [
    {
        "id": 196,
        "codigoPais": "PER",
        "codigoDepartamento": "00",
        "codigoProvincia": "00",
        "nombre": "SIN RESPUESTA"
    },
    {
        "id": 1,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "nombre": "ABANCAY"
    },
    {
        "id": 2,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "nombre": "ACOBAMBA"
    },
    {
        "id": 3,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "02",
        "nombre": "ACOMAYO"
    },
    {
        "id": 4,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "02",
        "nombre": "AIJA"
    },
    {
        "id": 5,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "02",
        "nombre": "ALTO AMAZONAS"
    },
    {
        "id": 6,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "nombre": "AMBO"
    },
    {
        "id": 7,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "nombre": "ANDAHUAYLAS"
    },
    {
        "id": 8,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "nombre": "ANGARAES"
    },
    {
        "id": 9,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "nombre": "ANTA"
    },
    {
        "id": 10,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "04",
        "nombre": "ANTABAMBA"
    },
    {
        "id": 11,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "16",
        "nombre": "ANTONIO RAIMONDI"
    },
    {
        "id": 12,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "nombre": "AREQUIPA"
    },
    {
        "id": 13,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "nombre": "ASCOPE"
    },
    {
        "id": 14,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "18",
        "nombre": "ASUNCION"
    },
    {
        "id": 15,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "03",
        "nombre": "ATALAYA"
    },
    {
        "id": 16,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "nombre": "AYABACA"
    },
    {
        "id": 17,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "nombre": "AYMARAES"
    },
    {
        "id": 18,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "nombre": "AZANGARO"
    },
    {
        "id": 19,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "02",
        "nombre": "BAGUA"
    },
    {
        "id": 20,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "09",
        "nombre": "BARRANCA"
    },
    {
        "id": 21,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "07",
        "nombre": "BELLAVISTA"
    },
    {
        "id": 22,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "02",
        "nombre": "BOLIVAR"
    },
    {
        "id": 23,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "nombre": "BOLOGNESI"
    },
    {
        "id": 24,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "nombre": "BONGARA"
    },
    {
        "id": 25,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "02",
        "nombre": "CAJABAMBA"
    },
    {
        "id": 26,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "nombre": "CAJAMARCA"
    },
    {
        "id": 27,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "02",
        "nombre": "CAJATAMBO"
    },
    {
        "id": 28,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "nombre": "CALCA"
    },
    {
        "id": 29,
        "codigoPais": "PER",
        "codigoDepartamento": "24",
        "codigoProvincia": "01",
        "nombre": "CALLAO"
    },
    {
        "id": 30,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "nombre": "CAMANA"
    },
    {
        "id": 31,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "nombre": "CANAS"
    },
    {
        "id": 32,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "nombre": "CANCHIS"
    },
    {
        "id": 33,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "04",
        "nombre": "CANDARAVE"
    },
    {
        "id": 34,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "nombre": "CANETE"
    },
    {
        "id": 35,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "02",
        "nombre": "CANGALLO"
    },
    {
        "id": 36,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "03",
        "nombre": "CANTA"
    },
    {
        "id": 37,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "nombre": "CARABAYA"
    },
    {
        "id": 38,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "nombre": "CARAVELI"
    },
    {
        "id": 39,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "nombre": "CARHUAZ"
    },
    {
        "id": 40,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "17",
        "nombre": "CARLOS FERMIN FITZCARRALD"
    },
    {
        "id": 41,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "05",
        "nombre": "CASMA"
    },
    {
        "id": 42,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "nombre": "CASTILLA"
    },
    {
        "id": 43,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "nombre": "CASTROVIRREYNA"
    },
    {
        "id": 44,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "nombre": "CAYLLOMA"
    },
    {
        "id": 45,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "nombre": "CELENDIN"
    },
    {
        "id": 46,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "nombre": "CHACHAPOYAS"
    },
    {
        "id": 47,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "08",
        "nombre": "CHANCHAMAYO"
    },
    {
        "id": 48,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "09",
        "nombre": "CHEPEN"
    },
    {
        "id": 49,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "nombre": "CHICLAYO"
    },
    {
        "id": 50,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "nombre": "CHINCHA"
    },
    {
        "id": 51,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "nombre": "CHINCHEROS"
    },
    {
        "id": 52,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "nombre": "CHOTA"
    },
    {
        "id": 53,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "04",
        "nombre": "CHUCUITO"
    },
    {
        "id": 54,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "nombre": "CHUMBIVILCAS"
    },
    {
        "id": 55,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "nombre": "CHUPACA"
    },
    {
        "id": 56,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "nombre": "CHURCAMPA"
    },
    {
        "id": 57,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "nombre": "CONCEPCION"
    },
    {
        "id": 58,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "nombre": "CONDESUYOS"
    },
    {
        "id": 59,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "06",
        "nombre": "CONDORCANQUI"
    },
    {
        "id": 60,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "02",
        "nombre": "CONTRALMIRANTE VILLAR"
    },
    {
        "id": 61,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "nombre": "CONTUMAZA"
    },
    {
        "id": 62,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "01",
        "nombre": "CORONEL PORTILLO"
    },
    {
        "id": 63,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "06",
        "nombre": "CORONGO"
    },
    {
        "id": 64,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "05",
        "nombre": "COTABAMBAS"
    },
    {
        "id": 65,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "nombre": "CUSCO"
    },
    {
        "id": 66,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "nombre": "CUTERVO"
    },
    {
        "id": 67,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "nombre": "DANIEL ALCIDES CARRION"
    },
    {
        "id": 68,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "07",
        "nombre": "DATEM DEL MARAÑON"
    },
    {
        "id": 69,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "nombre": "DOS DE MAYO"
    },
    {
        "id": 70,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "12",
        "nombre": "EL COLLAO"
    },
    {
        "id": 71,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "10",
        "nombre": "EL DORADO"
    },
    {
        "id": 72,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "nombre": "ESPINAR"
    },
    {
        "id": 73,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "02",
        "nombre": "FERRENAFE"
    },
    {
        "id": 74,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "nombre": "GENERAL SANCHEZ CERRO"
    },
    {
        "id": 75,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "11",
        "nombre": "GRAN CHIMU"
    },
    {
        "id": 76,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "nombre": "GRAU"
    },
    {
        "id": 77,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "09",
        "nombre": "HUACAYBAMBA"
    },
    {
        "id": 78,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "07",
        "nombre": "HUALGAYOC"
    },
    {
        "id": 79,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "02",
        "nombre": "HUALLAGA"
    },
    {
        "id": 80,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "nombre": "HUAMALIES"
    },
    {
        "id": 81,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "nombre": "HUAMANGA"
    },
    {
        "id": 82,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "08",
        "nombre": "HUANCA SANCOS"
    },
    {
        "id": 83,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "nombre": "HUANCABAMBA"
    },
    {
        "id": 84,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "nombre": "HUANCANE"
    },
    {
        "id": 85,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "nombre": "HUANCAVELICA"
    },
    {
        "id": 86,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "nombre": "HUANCAYO"
    },
    {
        "id": 87,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "nombre": "HUANTA"
    },
    {
        "id": 88,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "nombre": "HUANUCO"
    },
    {
        "id": 89,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "nombre": "HUARAL"
    },
    {
        "id": 90,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "nombre": "HUARAZ"
    },
    {
        "id": 91,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "nombre": "HUARI"
    },
    {
        "id": 92,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "19",
        "nombre": "HUARMEY"
    },
    {
        "id": 93,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "nombre": "HUAROCHIRI"
    },
    {
        "id": 94,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "nombre": "HUAURA"
    },
    {
        "id": 95,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "nombre": "HUAYLAS"
    },
    {
        "id": 96,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "nombre": "HUAYTARA"
    },
    {
        "id": 97,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "nombre": "ICA"
    },
    {
        "id": 98,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "03",
        "nombre": "ILO"
    },
    {
        "id": 99,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "07",
        "nombre": "ISLAY"
    },
    {
        "id": 100,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "nombre": "JAEN"
    },
    {
        "id": 101,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "nombre": "JAUJA"
    },
    {
        "id": 102,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "03",
        "nombre": "JORGE BASADRE"
    },
    {
        "id": 103,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "10",
        "nombre": "JULCAN"
    },
    {
        "id": 104,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "04",
        "nombre": "JUNIN"
    },
    {
        "id": 105,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "nombre": "LA CONVENCION"
    },
    {
        "id": 106,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "nombre": "LA MAR"
    },
    {
        "id": 107,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "nombre": "LA UNION"
    },
    {
        "id": 108,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "nombre": "LAMAS"
    },
    {
        "id": 109,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "nombre": "LAMBAYEQUE"
    },
    {
        "id": 110,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "nombre": "LAMPA"
    },
    {
        "id": 111,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "10",
        "nombre": "LAURICOCHA"
    },
    {
        "id": 112,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "06",
        "nombre": "LEONCIO PRADO"
    },
    {
        "id": 113,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "nombre": "LIMA"
    },
    {
        "id": 114,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "03",
        "nombre": "LORETO"
    },
    {
        "id": 115,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "nombre": "LUCANAS"
    },
    {
        "id": 116,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "nombre": "LUYA"
    },
    {
        "id": 117,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "02",
        "nombre": "MANU"
    },
    {
        "id": 118,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "05",
        "nombre": "MARANON"
    },
    {
        "id": 119,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "04",
        "nombre": "MARISCAL CACERES"
    },
    {
        "id": 120,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "nombre": "MARISCAL LUZURIAGA"
    },
    {
        "id": 121,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "01",
        "nombre": "MARISCAL NIETO"
    },
    {
        "id": 122,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "06",
        "nombre": "MARISCAL RAMON CASTILLA"
    },
    {
        "id": 123,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "nombre": "MAYNAS"
    },
    {
        "id": 124,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "nombre": "MELGAR"
    },
    {
        "id": 125,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "13",
        "nombre": "MOHO"
    },
    {
        "id": 126,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "nombre": "MORROPON"
    },
    {
        "id": 127,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "01",
        "nombre": "MOYOBAMBA"
    },
    {
        "id": 128,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "03",
        "nombre": "NAZCA"
    },
    {
        "id": 129,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "nombre": "OCROS"
    },
    {
        "id": 130,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "nombre": "OTUZCO"
    },
    {
        "id": 131,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "03",
        "nombre": "OXAPAMPA"
    },
    {
        "id": 132,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "10",
        "nombre": "OYON"
    },
    {
        "id": 133,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "05",
        "nombre": "PACASMAYO"
    },
    {
        "id": 134,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "07",
        "nombre": "PACHITEA"
    },
    {
        "id": 135,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "02",
        "nombre": "PADRE ABAD"
    },
    {
        "id": 136,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "05",
        "nombre": "PAITA"
    },
    {
        "id": 137,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "nombre": "PALLASCA"
    },
    {
        "id": 138,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "05",
        "nombre": "PALPA"
    },
    {
        "id": 139,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "nombre": "PARINACOCHAS"
    },
    {
        "id": 140,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "nombre": "PARURO"
    },
    {
        "id": 141,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "nombre": "PASCO"
    },
    {
        "id": 142,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "nombre": "PATAZ"
    },
    {
        "id": 143,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "nombre": "PAUCAR DEL SARA SARA"
    },
    {
        "id": 144,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "11",
        "nombre": "PAUCARTAMBO"
    },
    {
        "id": 145,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "nombre": "PICOTA"
    },
    {
        "id": 146,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "nombre": "PISCO"
    },
    {
        "id": 147,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "nombre": "PIURA"
    },
    {
        "id": 148,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "11",
        "nombre": "POMABAMBA"
    },
    {
        "id": 149,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "08",
        "nombre": "PUERTO INCA"
    },
    {
        "id": 150,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "nombre": "PUNO"
    },
    {
        "id": 151,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "04",
        "nombre": "PURUS"
    },
    {
        "id": 152,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "nombre": "QUISPICANCHIS"
    },
    {
        "id": 153,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "nombre": "RECUAY"
    },
    {
        "id": 154,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "nombre": "REQUENA"
    },
    {
        "id": 155,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "nombre": "RIOJA"
    },
    {
        "id": 156,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "nombre": "RODRIGUEZ DE MENDOZA"
    },
    {
        "id": 157,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "11",
        "nombre": "SAN ANTONIO DE PUTINA"
    },
    {
        "id": 158,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "11",
        "nombre": "SAN IGNACIO"
    },
    {
        "id": 159,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "12",
        "nombre": "SAN MARCOS"
    },
    {
        "id": 160,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "nombre": "SAN MARTIN"
    },
    {
        "id": 161,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "nombre": "SAN MIGUEL"
    },
    {
        "id": 162,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "13",
        "nombre": "SAN PABLO"
    },
    {
        "id": 163,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "09",
        "nombre": "SAN ROMAN"
    },
    {
        "id": 164,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "nombre": "SANCHEZ CARRION"
    },
    {
        "id": 165,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "nombre": "SANDIA"
    },
    {
        "id": 166,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "nombre": "SANTA"
    },
    {
        "id": 167,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "nombre": "SANTA CRUZ"
    },
    {
        "id": 168,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "nombre": "SANTIAGO DE CHUCO"
    },
    {
        "id": 169,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "nombre": "SATIPO"
    },
    {
        "id": 170,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "08",
        "nombre": "SECHURA"
    },
    {
        "id": 171,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "nombre": "SIHUAS"
    },
    {
        "id": 172,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "nombre": "SUCRE"
    },
    {
        "id": 173,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "nombre": "SULLANA"
    },
    {
        "id": 174,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "nombre": "TACNA"
    },
    {
        "id": 175,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "03",
        "nombre": "TAHUAMANU"
    },
    {
        "id": 176,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "07",
        "nombre": "TALARA"
    },
    {
        "id": 177,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "01",
        "nombre": "TAMBOPATA"
    },
    {
        "id": 178,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "nombre": "TARATA"
    },
    {
        "id": 179,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "nombre": "TARMA"
    },
    {
        "id": 180,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "nombre": "TAYACAJA"
    },
    {
        "id": 181,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "08",
        "nombre": "TOCACHE"
    },
    {
        "id": 182,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "nombre": "TRUJILLO"
    },
    {
        "id": 183,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "01",
        "nombre": "TUMBES"
    },
    {
        "id": 184,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "05",
        "nombre": "UCAYALI"
    },
    {
        "id": 185,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "13",
        "nombre": "URUBAMBA"
    },
    {
        "id": 186,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "07",
        "nombre": "UTCUBAMBA"
    },
    {
        "id": 187,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "nombre": "VICTOR FAJARDO"
    },
    {
        "id": 188,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "nombre": "VILCAS HUAMAN"
    },
    {
        "id": 189,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "12",
        "nombre": "VIRU"
    },
    {
        "id": 190,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "nombre": "YAROWILCA"
    },
    {
        "id": 191,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "nombre": "YAULI"
    },
    {
        "id": 192,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "nombre": "YAUYOS"
    },
    {
        "id": 193,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "nombre": "YUNGAY"
    },
    {
        "id": 194,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "10",
        "nombre": "YUNGUYO"
    },
    {
        "id": 195,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "03",
        "nombre": "ZARUMILLA"
    }
    
]